import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios.js";

const LessonAssign = () => {
    const [lessons, setLessons] = useState([]);
    const [selected, setSelected] = useState(new Set());
    const [loading, setLoading] = useState(true);
    const [assigning, setAssigning] = useState(false);
    const [positions, setPositions] = useState([]);
    const [selectedPositions, setSelectedPositions] = useState(new Set());
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/api/lessons')
            .then(r => setLessons(r.data || []))
            .catch(e => console.error(e))
            .finally(() => setLoading(false));

        // fetch positions
        api.get('/api/positions')
            .then(r => setPositions(r.data || []))
            .catch(e => console.error('positions fetch', e));
    }, []);

    const toggle = (id) => {
        setSelected(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id); else next.add(id);
            return next;
        });
    }

    const assignSelected = async () => {
        if (selected.size === 0) return;
        setAssigning(true);
        try {
            const res = await api.post('/api/lessons/assign', { lessonIds: Array.from(selected), positions: Array.from(selectedPositions) });
            console.log('Assign result', res.data);
            // simple feedback: clear selection
            setSelected(new Set());
            setSelectedPositions(new Set());
            alert('Assigned successfully');
        } catch (err) {
            console.error(err);
            alert('Assign failed');
        } finally {
            setAssigning(false);
        }
    }

    return (
        <>
            <div className="assign-wrapper">
                <div className="assign-title">
                    <p>Select lessons</p>
                    <p>Please select the lesson(s) to assign or delete.</p>
                </div>

                {loading && <p>Loading...</p>}
                {!loading && lessons.length === 0 && <p>Empty</p>}
                {!loading && lessons.length > 0 && (
                    <>
                        <div className="assign-inner">
                            <ul>
                                {lessons.map((l, index) => (
                                    <li key={l.id}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={selected.has(l.id)}
                                                onChange={() => toggle(l.id)}
                                                style={{ accentColor: "black" }}
                                            />
                                            {' '}{l.filename}
                                        </label>
                                        {/* <img src="/images/lesson.png" /> */}
                                        <img src={`/images/lesson${index + 1}.png`} alt="lesson"  />
                                    </li>
                                ))}
                            </ul>
                            <div className="flex-button">
                                <button onClick={() => navigate('/manager/dashboard/lessons/assign/positions', {
                                    state: {
                                        selected: Array.from(selected),
                                        fileNames: Array.from(selected).map(id => lessons.find(l => String(l.id) === String(id))?.filename).filter(Boolean)
                                    }
                                }
                                )}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div >
        </>
    )
}

export default LessonAssign;